// extracted by mini-css-extract-plugin
export default {"addform":"AddForm_addform__WX4MS","main4":"AddForm_main4__M+2CL"};